module.exports = __webpack_public_path__ + "static/img/meikuangAQ_details.bd8ca728.jpg";